module.exports = __webpack_public_path__ + "static/media/Atlan-logo-full.3e9a8d4a.svg";